import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Notification} from "../model/notification";
import {NotificationService} from "../service/notification.service";

@Injectable()
export class NotificationResolve implements Resolve<Notification> {
    constructor(private notificationService: NotificationService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Notification> {
        return this.notificationService.getById(route.params.id);
    }
}
